import { Component, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { scrollToSection } from '@/app/shared/helpers';

@Component({
  selector: '[app-navbar]',
  standalone: true,
  imports: [RouterModule],
  template: `
    <div
      class="fixed inset-x-0 top-0 z-40 backdrop-blur bg-surface-0/80 dark:bg-surface-950/80 border-b"
    >
      <div
        class="landing-container flex items-center justify-between py-4 gap-4"
      >
        <a routerLink="/landing" class="flex items-center gap-2 shrink-0">
          <span
            class="w-9 h-9 rounded-full bg-primary-active flex items-center justify-center text-surface-0"
          >
            <i class="pi pi-chart-line"></i>
          </span>
          <span class="text-lg font-semibold">PlanTrack</span>
        </a>

        <nav class="hidden md:flex items-center gap-8">
          @for (link of links; track link.href) {
            <a
              [href]="link.href"
              (click)="scrollTo(link.id, $event)"
              class="text-surface-600 dark:text-surface-300 hover:text-surface-950 dark:hover:text-surface-0 transition-colors"
            >
              {{ link.label }}
            </a>
          }
        </nav>

        <div class="hidden md:flex items-center gap-3 shrink-0">
          <a routerLink="/auth/login" class="landing-button-secondary">
            Iniciar Sesión
          </a>
          <a
            href="#contacto"
            (click)="scrollTo('contacto', $event)"
            class="landing-button-primary"
          >
            Solicitar una demo
          </a>
        </div>

        <button
          type="button"
          class="md:hidden w-10 h-10 flex items-center justify-center rounded-full hover:bg-surface-100 dark:hover:bg-surface-900"
          (click)="menuOpen.set(!menuOpen())"
        >
          <i
            class="pi !text-lg"
            [class.pi-bars]="!menuOpen()"
            [class.pi-times]="menuOpen()"
          ></i>
        </button>
      </div>

      @if (menuOpen()) {
        <div class="md:hidden landing-container pb-6 flex flex-col gap-4">
          @for (link of links; track link.href) {
            <a
              [href]="link.href"
              (click)="scrollTo(link.id, $event); menuOpen.set(false)"
              class="text-surface-600 dark:text-surface-300"
            >
              {{ link.label }}
            </a>
          }
          <div class="flex flex-col gap-3 pt-2">
            <a
              routerLink="/auth/login"
              class="landing-button-secondary text-center"
            >
              Iniciar Sesión
            </a>
            <a
              href="#contacto"
              (click)="scrollTo('contacto', $event); menuOpen.set(false)"
              class="landing-button-primary text-center"
            >
              Solicitar una demo
            </a>
          </div>
        </div>
      }
    </div>
  `,
  host: {
    class: 'block',
  },
})
export class Navbar {
  menuOpen = signal(false);

  links = [
    {
      label: 'Características',
      id: 'caracteristicas',
      href: '#caracteristicas',
    },
    { label: 'Cómo funciona', id: 'como-funciona', href: '#como-funciona' },
    { label: 'Planes', id: 'planes', href: '#planes' },
    { label: 'Contáctenos', id: 'contacto', href: '#contacto' },
  ];

  scrollTo(id: string, event: Event): void {
    scrollToSection(id, event);
  }
}
